import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "19", x2: "5", y1: "5", y2: "19", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "6.5", cy: "6.5", r: "2.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "17.5", cy: "17.5", r: "2.5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Percent";
const Percent = memo(themed(Icon));
export {
  Percent
};
//# sourceMappingURL=percent.js.map
